module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.7@readable-stream/transform.js
// module id = 301
// module chunks = 8